"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = _interopRequireDefault(require("../../utils/core"));

var _jquery = _interopRequireDefault(require("jquery"));

var Header = _core["default"].Class.extend({
  constructor: function constructor(plugin, headerOptions) {
    this.plugin = plugin;
    this.headerOptions = headerOptions;
  },
  render: function render() {
    var p = this.plugin,
        $header = (0, _jquery["default"])('<div>').addClass('header');

    if (this.headerOptions) {
      if (_core["default"].isString(this.headerOptions.title)) {
        $header.text(this.headerOptions.title);
      }
    } else {
      $header.addClass('hidden');
    }

    return $header;
  }
});

var _default = Header;
exports["default"] = _default;